import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import Cookie from 'services/Cookie';
import authToken from 'store/selectors/authToken';

const IndexScene = () => {
  const navigate = useNavigate();
  const token = useSelector(authToken);
  const hasSession = useMemo(() => Boolean(token?.hash || Cookie.get('token')?.hash), [token]);

  useEffect(() => {
    if (hasSession) {
      navigate('/home/messages');
    } else {
      navigate('/auth/login');
    }
  }, [hasSession, navigate]);

  return null;
};

export default IndexScene;
